import { Role } from '../models/role'
import VueRouter, { RouteConfig } from 'vue-router'
import { PermissionService } from 'kuaidong-service'
import { teacherStore, loginStore, menuRoleStore } from 'kuaidong-store'

export default class RouterService {
  constructor(public router: VueRouter) {}

  get menuItems() {
    return this.buildMenuItems(this.router.options.routes)
  }

  get permissons() {
    return new PermissionService(
      teacherStore.userRoleInfo,
      teacherStore.teacher,
      menuRoleStore.menuRole
    ).buildPermissions()
  }

  hasRole(route: RouteConfig, role: string) {
    return !!route?.meta?.roles?.includes(role)
  }

  hasRoles(route: RouteConfig, roles: string[]) {
    return roles.some((role) => this.hasRole(route, role))
  }

  hasPermission(route: RouteConfig) {
    if (loginStore.organization) {
      return this.hasRole(route, loginStore.organization.role)
    }

    if (this.hasRole(route, Role.Admin)) {
      return !!teacherStore.isAdmin
    }

    if (this.hasRole(route, Role.Verified)) {
      return !!teacherStore.isVerifiedSchool
    }

    if (this.hasRole(route, Role.UserAccount)) {
      return teacherStore.hasUserAccountPermission
    }

    if (this.hasRoles(route, Object.values(Role))) {
      return false
    }

    if (route.meta?.rolesKey) {
      return this.permissons.m.hasPermission(this.permissons.m.getRoles(route.meta.rolesKey))
    }

    return true
  }

  public buildMenuItems(routes?: RouteConfig[]) {
    const menuItems: RouteConfig[] = []

    if (routes) {
      for (const route of routes) {
        if (route.meta?.showMenu && this.hasPermission(route)) {
          const routeCopy = { ...route }

          routeCopy.children = this.buildMenuItems(route.children)

          menuItems.push(routeCopy)
        } else {
          menuItems.push(...this.buildMenuItems(route.children))
        }
      }
    }

    return menuItems
  }
}
